import React, { HTMLAttributes } from "react";
import "./DNAElementBox.scss";

export function DNAElementBox({
    className = '',
    children,
    ...otherProps
                              }: HTMLAttributes<HTMLDivElement>) {
    return (
        <div className={`dna-element-box-wrapper ${className}`} {...otherProps}>
            {children}
        </div>
    )
}
